import { render, staticRenderFns } from "./instagramImageErrorPlaceholder.vue?vue&type=template&id=3be0c5c6&scoped=true&"
import script from "./instagramImageErrorPlaceholder.vue?vue&type=script&lang=js&"
export * from "./instagramImageErrorPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./instagramImageErrorPlaceholder.vue?vue&type=style&index=0&id=3be0c5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0c5c6",
  null
  
)

export default component.exports